import React from 'react';
import {
	BarChart,
	Bar,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	Legend
} from 'recharts';
import { addCommasToBigNumbers } from '../../util/helperFunctions';
import {
	breakdownColorCodeData,
	getRandomColor,
	prepForBar
} from '../../util/databaseFunctions';
import { Columns } from 'bloomer/lib/grid/Columns';
import { Column } from 'bloomer/lib/grid/Column';
import Bold from '../Bold';
import { Title } from 'bloomer/lib/elements/Title';

export default class BarChartWithPreamble extends React.Component {
	constructor() {
		super();
		this.state = {
			colorData: [],
			color: getRandomColor()
		};
	}
	componentDidMount() {
		const colorBreakdown = breakdownColorCodeData(this.props.data);
		const colorData = prepForBar(colorBreakdown);
		this.setState({
			colorData: colorData
		});
	}
	render() {
		const { animalType } = this.props;
		return (
			<div>
				<Title tag="h3">If we break down the enrichment time by color code, we get:</Title>
				<Columns>
					<Column>
						<ul>
							{this.state.colorData.map(colorCode => (
								<li key={`${colorCode.name}Key`}>
									<p>
										{' '}
										<Bold>{colorCode.name}</Bold>:{' '}
										{addCommasToBigNumbers(Math.round(colorCode['Minutes of Enrichment']))}
										<Bold>
											{' '}({(
												colorCode['Minutes of Enrichment'] /
												this.props.totalTime *
												100
											).toFixed(2)}%)
									</Bold>{' '}
										of total time spent enriching {animalType}s was spent on {colorCode.name} {animalType}s.
								</p>
								</li>
							))}
						</ul>
					</Column>
					<Column className="on-print-is-one-half">
						<BarChart
							width={600}
							height={300}
							data={this.state.colorData}
							margin={{ top: 15, right: 30, left: 20, bottom: 25 }}
						>
							<XAxis dataKey="name" />
							<YAxis />
							<CartesianGrid strokeDasharray="3 3" />
							<Tooltip />
							<Bar
								dataKey="Minutes of Enrichment"
								fill={this.state.color}
							/>
							<Legend
								wrapperStyle={{ bottom: 0 }}
							/>
						</BarChart>
					</Column>
				</Columns>
			</div>
		);
	}
}
